import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const FIELD_CONFIG = [
  { key: 'allWords', label: 'All of these words', placeholder: 'e.g. react node graphql' },
  { key: 'anyWords', label: 'Any of these words', placeholder: 'e.g. figma adobe sketch' },
  { key: 'noneWords', label: 'None of these words', placeholder: 'e.g. php wordpress' },
  { key: 'exactPhrase', label: 'The exact phrase', placeholder: 'e.g. "design system"' },
  { key: 'titleSearch', label: 'Title search', placeholder: 'e.g. senior front-end' },
  { key: 'skillsSearch', label: 'Skills search', placeholder: 'e.g. React, TypeScript, GraphQL' },
];

const EMPTY_VALUES = FIELD_CONFIG.reduce((acc, field) => {
  acc[field.key] = '';
  return acc;
}, {});

const JobAdvancedSearchModal = ({ values, onApply, onClose }) => {
  const [draft, setDraft] = useState(values || EMPTY_VALUES);

  useEffect(() => {
    setDraft(values || EMPTY_VALUES);
  }, [values]);

  const hasValues = Object.values(draft).some((value) => value.trim());

  const handleChange = (key, value) => {
    setDraft((prev) => ({ ...prev, [key]: value }));
  };

  const handleClear = () => {
    setDraft(EMPTY_VALUES);
  };

  const handleApply = () => {
    onApply(draft);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div
        className="relative w-[92%] max-w-2xl bg-white rounded-2xl shadow-xl"
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Advanced search</h2>
            <p className="text-xs text-gray-500 mt-1">Refine results with precise keyword matching.</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
            aria-label="Close advanced search"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-6 py-5 space-y-4 max-h-[70vh] overflow-y-auto">
          {FIELD_CONFIG.map((field) => (
            <div key={field.key} className="space-y-1.5">
              <label className="text-sm font-medium text-gray-800">{field.label}</label>
              <input
                type="text"
                value={draft[field.key]}
                onChange={(e) => handleChange(field.key, e.target.value)}
                placeholder={field.placeholder}
                className="w-full px-4 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
              />
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
          {hasValues ? (
            <button
              type="button"
              onClick={handleClear}
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
            >
              Clear all
            </button>
          ) : (
            <span />
          )}
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleApply}
              className="px-5 py-2 text-sm font-semibold bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobAdvancedSearchModal;
